import { Card, Col, Dropdown } from 'react-bootstrap'
import face1 from "../../../../../Utils/assets/img/faces/5.jpg"
import face2 from "../../../../../Utils/assets/img/faces/6.jpg"
import face3 from "../../../../../Utils/assets/img/faces/7.jpg"
import { GetRequest } from '../../../../../Utils/hooks/ApiHandler'
import { useEffect, useState } from 'react'
import { useGetEssentials } from '../../../../../Utils/hooks/useGetEssentials'
import nodata from "../../../../../Utils/assets/img/leads_no_data_found_removebg.png"

const DEFAULT_AVATAR = [face1, face2, face3]

export const RevenueGenerators = () => {

    const { customerId, headers, extras } = useGetEssentials()
    // Component state for selecting the timeframe
    const [selectedPeriod, setSelectedPeriod] = useState("today");
    const [revenueGenerators, setRevenueGenerators] = useState(null)

    const revenueDataPeriod = [
        { value: 'today', title: "Today" },
        { value: 'week', title: "This Week" },
        { value: 'month', title: "This Month" }
    ]

    const fetchRevenueGenerators = async () => {
        try {
            const res = await GetRequest(`dashboard/revenueGenerator/${customerId}/${selectedPeriod}`, { headers }, extras)
            if (res.status === 'fail' || res.success === false) {
                setRevenueGenerators(null)
                return
            }
            setRevenueGenerators(res.data)
        } catch (error) {
            return
        }
    }

    useEffect(() => {
        fetchRevenueGenerators()
    }, [selectedPeriod])

    return (
        <Col lg={3}>
            <Card className="h-100 rounded-3 p-0 position-relativse" style={{ backgroundColor: "#ffffff", border: "1px solid #e3e3e3" }}>
                <Card.Body className="p-3 d-flex flex-column justify-content-between h-100">
                    <div>
                        <div className="d-flex align-items-center justify-content-between mb-1">
                            <span className="fw-semibold text-dark" style={{ fontSize: '14.5px' }}>
                                Top Revenue Generators
                            </span>
                            <Dropdown as="div" align={"end"} >
                                <Dropdown.Toggle
                                    as="button"
                                    className="btn btn-light d-flex align-items-center gap-2 px-2 py-1 text-muted no-arrow"
                                    style={{ fontSize: '12px', borderRadius: '8px', fontWeight: '600', border: '1px solid #efefef', textTransform: 'capitalize' }}
                                >
                                    <span className="text-capitalize">{selectedPeriod}</span>
                                    <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                    className="shadow"
                                    style={{
                                        width: "10rem",
                                        padding: "8px 0px",
                                        right: "3.4rem",
                                    }}
                                >
                                    {
                                        revenueDataPeriod?.map(c => (
                                            <Dropdown.Item
                                                href="#"
                                                className="d-flex align-items-center"
                                                onClick={() => setSelectedPeriod(c.value)}
                                            >
                                                {c.title}
                                            </Dropdown.Item>
                                        ))
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>
                            Highest closed contract value
                        </span>

                        <hr className="my-2" style={{ opacity: 0.1, backgroundColor: "#000" }} />

                        <div className="position-relative d-flex flex-column gap-2">
                            {revenueGenerators ?
                                revenueGenerators?.map((person, index) => (
                                    <>
                                        <div
                                            key={person.rank}
                                            className={`d-flex align-items-center justify-content-between py-2`}
                                            style={{ borderColor: "#f1f5f9" }}
                                        >
                                            <div className="d-flex align-items-center gap-2">
                                                <img
                                                    src={person.img || DEFAULT_AVATAR[index % DEFAULT_AVATAR.length]}
                                                    alt={person.name}
                                                    className="rounded-circle object-fit-cover"
                                                    style={{ width: "32px", height: "32px", border: "1px solid #e2e8f0" }}
                                                />
                                                <span className=" text-dark d-block" style={{ fontWeight: 600, fontSize: "12.5px", lineHeight: "1.2" }}>
                                                    {person.name}
                                                </span>
                                            </div>
                                            <div className="text-end">
                                                <strong className="fw-medium text-dark d-block" style={{ fontSize: "16px" }}>
                                                    {person.val}
                                                </strong>
                                            </div>
                                        </div>
                                        <hr className='m-0' />
                                    </>
                                ))
                                :
                                <>
                                    <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ position: "absolute", left: "16%" }}
                                    >
                                        <img
                                            src={nodata}
                                            alt=""
                                            style={{ width: "17rem", marginTop: "0" }}
                                        />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    )
}
